window.addEventListener('DOMContentLoaded', function() {
    if (window.innerWidth <= 768) {
        // Try finding common hamburger menu classes
        var hamburgerMenu = document.querySelector('.hamburger, .menu-toggle, .nav-toggle, .header__hamburger');
        
        if (hamburgerMenu) {
            hamburgerMenu.style.display = 'none'; // Hide the hamburger menu
        }
    }
});
